import { Component, State, h, Host, Prop, Method, Element, Watch } from '@stencil/core';

@Component({
  tag: "lk-toggle"
})
export class Toggle {

  @Prop() hasCounter: boolean = false;
  @Prop() displayOnMobile: boolean; // Deprecated
  @Prop({ mutable: true }) hideButtonOnDesktop: boolean = false;
  @Prop({ reflect: true }) color: string = "green";
  @Prop({ mutable: true }) compact: boolean = false;
  @Prop({ reflect: true }) small: boolean = false;
  @Prop() opened: boolean = false;
  @Prop() background = null;
  @Prop() contentContainerClasses = "";

  @Prop() isLKClonerChild: boolean = false;
  @State() expanded: boolean = false;

  @Element() el: HTMLElement;

  refAccordionDiv: HTMLDivElement;
  isFirstRenderAsClone = false

  @Method()
  async changeDisplayStatus(display: boolean) {
    this.expanded = display;
  }

  @Watch('isLKClonerChild')
  isLKClonerChildChanged(state, pastState) {
    if (state == true && pastState == false && this.opened) {
      this.isFirstRenderAsClone = true
    }
  }

  @Method()
  async isExpanded() {
    return this.expanded;
  }

  handleToggleButton(event) {
    event.preventDefault();

    this.expanded = !this.expanded;
    if (this.expanded == true) {
      this.refAccordionDiv.removeAttribute("hidden");
    }
  }

  componentWillLoad() {
    if (this.displayOnMobile !== undefined)
      this.hideButtonOnDesktop = this.displayOnMobile; // for legacy support

    if (this.hideButtonOnDesktop)
      this.expanded = false;

    if (this.opened) {
      this.expanded = true;
    }

    if (this.compact == false) {
      this.compact = this.small;
    }
  }

  componentDidLoad() {
    if (this.expanded) {
      this.setAccordionHeight("none");
      this.refAccordionDiv.removeAttribute("hidden");
    } else {
      this.setAccordionHeight(0);
      this.refAccordionDiv.setAttribute("hidden", "");
    }
  }

  componentDidUpdate() {
    if (this.isFirstRenderAsClone) return this.isFirstRenderAsClone = false

    if (this.expanded) {
      this.setAccordionHeight(this.refAccordionDiv.scrollHeight);
    } else {
      this.setAccordionHeight(0);
    }
  }

  showHideDelay(delay: number, value: boolean): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      setTimeout(() => {
        resolve(value)
      }, delay)
    })
  }

  render() {
    let hostClass = `toggle toggle--${this.color}
      ${this.hideButtonOnDesktop
        ? 'toggle--mobile toggle__no-border' : ''
      } ${this.compact
        ? 'toggle--compact' : ''
      } ${this.hasCounter
        ? 'toggle--left' : ''}`;

    let buttonClass = `toggle__button toggle-counter-button ${this.hideButtonOnDesktop
      ? 'toggle__button--mobile' : ''}`;

    let accordionClass = `toggle__accordion ${this.hideButtonOnDesktop
      ? 'toggle__accordion--mobile' : ''
      } ${this.hasCounter
        ? 'lk-toggle-list__border-left' : ''}`;

    let contentClass = `toggle__accordion__content ${this.hideButtonOnDesktop ? 'toggle__accordion__content--mobile' : ''}`

    return (
      <Host class={hostClass}>
        <button
          style={this.background ? { backgroundColor: this.background } : null}
          type="button"
          class={buttonClass}
          onClick={event => { this.handleToggleButton(event); }}
          aria-expanded={this.expanded}
        >
          <span
            class="toggle__button__icon"
            aria-hidden="true"
            style={{
              transform: this.expanded
                ? "rotate(-180deg)" : "rotate(0deg)"
            }}
          >
            <svg aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.299 6.3">
              <path d="M13.513.747l4.8,6.9-4.8,6.9" transform="translate(15.296 -12.763) rotate(90)" fill="none" stroke="currentColor"
                stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" />
            </svg>
          </span>

          <span class="toggle__button__label">
            <slot name="title" />
          </span>
        </button>

        <div
          ref={el => this.refAccordionDiv = el as HTMLDivElement}
          class={accordionClass}
          onTransitionEnd={() => {
            if (this.expanded) {
              this.refAccordionDiv.style.maxHeight = "none";
              this.refAccordionDiv.removeAttribute("hidden");
            } else {
              this.refAccordionDiv.setAttribute("hidden", "");
            }
          }}
          hidden
        >

          <div class={contentClass + ` ${this.contentContainerClasses}`} >
            <slot />
          </div>
        </div>
      </Host>
    );
  }

  setAccordionHeight(height) {
    if (this.refAccordionDiv.style.maxHeight == "none") {
      this.refAccordionDiv.style.maxHeight = this.refAccordionDiv.scrollHeight + "px";
    }

    requestAnimationFrame(() => { // Ensure the browser has had a chance to apply the previous style change
      requestAnimationFrame(() => { // safely apply next style change
        if (typeof height === "number") {
          this.refAccordionDiv.style.maxHeight = `${height}px`;
        } 
        else {
           this.refAccordionDiv.style.maxHeight = height
        }
      });
    });
  }
}
